import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { EQM1011_R01Dto } from "./Dto_EQM1011_R01";
import { EQM1011_R01Filter } from "./Store_EQM1011_R01";

const baseUrl = `${config.apiUrl}/EQM1011_R01`;

const getEQM1011_R01Params = (
    filter: Partial<EQM1011_R01Filter>,
) => ({
    compCd: filter.compCd || undefined,
    date: filter.baseDate ? formatDate(filter.baseDate) : undefined,
    plcaddressid: filter.plcaddressid ?? undefined,
});

export const getEQM1011_R01List = async (
    filter: Partial<EQM1011_R01Filter>,
) => {
    return getData<ResponseDto<EQM1011_R01Dto[]>>(baseUrl, {
        params: getEQM1011_R01Params(filter),
    });
};
